import { Dispatch, Middleware, MiddlewareAPI, UnknownAction } from '@reduxjs/toolkit';
import { notify } from 'components/Common/Toast';

type Store = MiddlewareAPI<Dispatch<UnknownAction>, any>;
// Middleware to handle success and error messages,
export const notificationMiddleware: Middleware = (store: Store) => (next) => (action: any) => {
    const { meta, type } = action;
    // Added message type support if we want to change the color of the toast in case we want to show info or warning
    const { successMessage, errorMessage, messageType } = meta || {};

    if (successMessage && type.endsWith('/fulfilled')) {
        notify(successMessage, messageType || 'success');
    } else if (errorMessage && type.endsWith('/rejected')) {
        notify(errorMessage, messageType || 'error');
    }

    // Pass the action to the next middleware or reducer
    return next(action);
};
